export default __webpack_public_path__ + "static/dismoi-screenshot-biet-thomas-mounted-website-desktop-2158cb839336dfe7e7da0237633f7b06.jpg";